import React, { useEffect, useState } from "react";
import HeadLines from "../CommonComponents/HeadLines";
import style from "./style.module.css";
import InputMobileNumber from "../CommonComponents/InputMobileNumber";
import { Validation } from "../../../../_helpers/validation/Validation";
import { userDetail } from "../GetInTouch/constant";
import { postAppLink } from "../../../../_services/Arya2.0/Homepage";
import { customToastr } from "../CustomToastr";
import { useTranslation } from "react-i18next";
import { isMobile } from "../helperFunc";
import CustomCheckBox from "../CommonComponents/CustomCheckBox/CustomCheckBox";
import Button from "../CommonComponents/Button";
import useUserLanguage from "../CustomHooks/useUserLanguage";
const initiate = {
  number: "",
};
const EnterNumber = (props) => {
  const [data, setData] = useState(initiate);
  const [error, setError] = useState("");
  const [checked, setChecked] = useState(false);

  const { t: translation } = useTranslation();
  const [disable, setDisable] = useState(true);
  useEffect(() => {
    if (props?.mobileNumber?.toString().length === 10) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, []);
  const onChange = (e) => {
    const { name, value } = e.target;
    if (value.toString().length <= 10) {
      setData((prev) => ({ ...prev, [name]: value }));
      if (e.target.value.toString().length === 10) {
        setDisable(false);
      } else {
        setDisable(true);
      }
    }
  };

  const AppLinkApi = async () => {
    let errobj = {};
    errobj = Validation(data, userDetail());
    setError(errobj);
    let flag = 0;
    Object.keys(errobj).forEach((index) => {
      if (errobj[index] !== "") {
        flag = 1;
      }
    });

    if (flag === 0) {
      let dataObj = {
        mobile: data.number,
        whatapp_send: checked ? 1 : 0,
        arya_shakti: props.aryaShakti,
      };
      const res = await postAppLink(dataObj);
      console.log(res);
      if (res?.status === "success") {
        customToastr({
          text: "Link sent successfully!",
          type: "success",
          // positionClass: tcs["toast-top-center2"],
          // toastClass: tcs["email-otp-toastr"],
        });
      }
    }
  };
  const { lang_id } = useUserLanguage();

  return (
    <>
      <div className={isMobile ? "" : "margin-left20 mtb-auto"}>
        {!isMobile && (
          <HeadLines
            text="Your Contact Number"
            className={
              "font-size14 line-height16 textColorWhite padding-bottom4 letterSpacing05"
            }
          />
        )}
        <div
          className={`d-flex flex-wrap ${
            isMobile ? style["margin-top20"] : ""
          }`}
        >
          <div className="flex50 margin-right8 width-100">
            <InputMobileNumber
              className1={`${
                props.mobileNumber ? style["whatsappWidget"] : ""
              }  ${
                style["padding-left38"]
              } boxRadius4 width-100 font-weight400 ${
                isMobile
                  ? "font-size12 line-height14 padding-top8 padding-bottom8"
                  : "font-size16 line-height19 padding-top12 padding-bottom12"
              } letterSpacing05 `}
              className2={`${
                props.mobileNumber ? style["whatsappWidget91"] : ""
              } ${style["positionTopBottom"]} font-weight400 ${
                isMobile
                  ? "font-size12 line-height14 "
                  : "font-size16 line-height19 "
              } letterSpacing05`}
              value={data.number}
              onChange={onChange}
              name="number"
              showError={translation(error.number)}
              placeholder={translation("Enter Number")}
              disable={props.mobileNumber ? true : false}
            />
          </div>
          <Button
            className={`${style["border-radius4"]} textColorWhite ${
              disable ? style["disableBackground"] : "backAccent3"
            }  overWriteInputButtonCSS padding-left8 padding-right8 ${
              !isMobile ? style["heightWidth"] : ""
            } ${lang_id !== "en" && !isMobile && style["lang-get-link-style"]}`}
            onClick={() => AppLinkApi()}
            title="Get Link"
          />
        </div>
        <div className={`d-flex align-items-center   margin-top8 `}>
          <CustomCheckBox
            id={`AppLink`}
            className="mb-auto"
            inputProps={{
              onChange: () => setChecked(!checked),
              checked: checked,
            }}
          />

          <HeadLines
            text={"Send link on Whatsapp"}
            className="letterSpacing05 padding-left8 textColorWhite font-size14 line-height16"
          />
        </div>
      </div>
    </>
  );
};
export default EnterNumber;
